module.exports = __webpack_public_path__ + "img/ballon-parc.6cda8360.png";